var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uuid!=undefined)?_c('div',{ref:_vm.uuid,style:(_vm.cssDim)}):_c('div',[_vm._v(" blank ")])}
var staticRenderFns = []

export { render, staticRenderFns }